import * as HttpUtils from '../utils/http'
import { getHost } from "@/utils/baseFn/filter";
let localhost = getHost()
// http://192.168.1.84:9999
let outUrl = 'https://api.binance.com'
/**
 * 获取交易规则和交易对
 * @param {*} params
 */
export function exInfo (params, country) {
  const url = `${country ? localhost : outUrl}/api/v3/exchangeInfo`

  return HttpUtils.JSON().get(url, params)
}

/**
 * 24hr 价格变动情况
 * @param {*} params
 */
export function tickerDay (params, country) {
  const url = `${country ? localhost : outUrl}/api/v3/ticker/24hr`
  return HttpUtils.JSON().get(url, params)
}

/**
 * 登录天眼评分
 * @param {*} params
 * https://oce.fx696.com:59105
 */
export function bitLogin (params) {
  // const url = `${country?'https://oce.fx696.com:59105':outUrl}/api/Permission/Login?username=gsw&password=2E6CAA66096F1D4BED0FE21EE5468FE2`
  const url = `https://oce.fx696.com:59105/api/Permission/Login?username=gsw&password=2E6CAA66096F1D4BED0FE21EE5468FE2`
  return HttpUtils.JSON().get(url, params)
}

/**
 * zorro.json
 * @param {*} params
 */
export function bitCode (params, country) {
  const url = `https://voice.fx994.com/zorro/zorro.json`
  return HttpUtils.JSON().get(url, params)
}

/**
 * 获取详情
 * @param {*} params
 */
export function bitScore (params, country) {
  const url = `https://oce.fx994.com:5300/WikiSearch/wikibit/detail?evaluationCode=${params}`
  return HttpUtils.JSON().get(url, params)
}

/**
 * k线 history
 * @param {*} params
 */
export function klineHis (params, country) {
  if (params.isFirst) {
    const url = `${country ? localhost : outUrl}/api/v3/klines?symbol=${params.symbol}&interval=${params.interval}&limit=${params.limit}`
    return HttpUtils.JSON().get(url, params)
    // &startTime=${params.startTime}&endTime=${params.endTime}
  } else {
    const url = `${country ? localhost : outUrl}/api/v3/klines?symbol=${params.symbol}&interval=${params.interval}&limit=${params.limit}&startTime=${params.startTime}&endTime=${params.endTime}`
    return HttpUtils.JSON().get(url, params)

  }
  // &startTime=${params.startTime}&endTime=${params.endTime}
}
/**
 * 深度图
 * @param {*} params
 */
export function depth (params, country) {
  const url = `${country ? localhost : outUrl}/api/v3/depth?symbol=${params.symbol}&limit=${params.limit}`
  return HttpUtils.JSON().get(url, params)
}
/**
 * 指数k线
 * @param {*} params
 */
export function indexKline (params, country) {
  const url = `${country ? localhost : outUrl}/api/quote/v1/index/klines`
  return HttpUtils.JSON().get(url, params)
}
/**
 * 指数计算公式
 * @param {*} params
 */
export function indexFormula (params, country) {
  const url = `${country ? localhost : outUrl}/api/quote/v1/index/config`
  return HttpUtils.JSON().get(url, params)
}

/**
 * 近期成交
 * @param {*} params
 */
export function recentTrade (params, country) {
  const url = `${country ? localhost : outUrl}/api/v3/trades?symbol=${params.symbol}&limit=${params.limit}`
  return HttpUtils.JSON().get(url, params)
}

/**
 * 服务器时间
 * @param {*} params
 */
export function serverTime (params, country) {
  const url = `${country ? localhost : outUrl}/api/v3/time`
  return HttpUtils.JSON().get(url, params)
}

/**
 * 最新成交
 * @param {*} params
 */
export function trade (params, country) {
  const url = `${country ? localhost : outUrl}/api/quote/v1/trades`
  return HttpUtils.JSON().get(url, params)
}

/**
 * 24小时行情http
 * @param {*} params
 */
export function quote (params, country) {
  const url = `${country ? localhost : outUrl}/api/quote/v1/broker/tickers`
  return HttpUtils.JSON().get(url, params)
}
/**
 * 检测ip地址
 * @param {*} params
 */
export function deteIp (params) {

  const url = `https://exportedbase.fx696.com/ip138/getcity`
  // const url = `${country?'https://oce.fx994.com:5300':outUrl}/Third/ip138/getcity?ip=${params}`
  return HttpUtils.JSON().get(url, params)
}
